export default function requiredWithPhone(value, form) {
    return !form.phone || !!value;
}
